import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function Header() {
  const { account, logout } = useAuth();

  return (
    <header className="app-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <Link to="/" style={{ fontSize: '15px', fontWeight: 500, color: 'var(--text-primary)' }}>AI Readiness</Link>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Link to="/help" style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
          Help
        </Link>
        <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
          {account?.name || account?.username || ''}
        </span>
        <button className="btn btn-secondary" onClick={logout} style={{ padding: '4px 12px' }}>
          Sign out
        </button>
      </div>
    </header>
  );
}
